// Batch "glance" summaries for a list of persons — one POST for the whole
// visible page (Deal Pipeline / Quotes table). Returns { summaries, refresh }.
import { useCallback, useEffect, useRef, useState } from "react";
import api from "../../lib/api";

export default function useActivitySummaries(personIds) {
  const [summaries, setSummaries] = useState({});
  const key = (personIds || []).filter(Boolean).join(",");
  const idsRef = useRef([]);
  idsRef.current = (personIds || []).filter(Boolean);

  const fetchNow = useCallback(async (ids) => {
    const list = ids || idsRef.current;
    if (!list.length) return;
    try {
      const { data } = await api.post("/crm/activities/summary", { person_ids: list });
      setSummaries((prev) => ({ ...prev, ...(data.summaries || {}) }));
    } catch { /* non-blocking */ }
  }, []);

  useEffect(() => {
    if (!key) return;
    const t = setTimeout(() => fetchNow(key.split(",")), 150);
    return () => clearTimeout(t);
  }, [key, fetchNow]);

  const refresh = useCallback(() => fetchNow(), [fetchNow]);
  return { summaries, refresh };
}
